<mat-form-field [color]="listModeFlag ? 'accent' : 'primary'" [ngClass]="{ 'list-mode': listModeFlag }" class="whole-width">
  <mat-label>{{ matLabel }}</mat-label>
  <mat-select
    #_matSelect
    (selectionChange)="onElementSelectionChange($event)"
    (valueChange)="valueChange($event)"
    [compareWith]="compareComboModels"
    [formControl]="comboFormControl"
    [required]="requiredFlag!"
  >
    @if (comboFormControl.value) {
      <mat-select-trigger
        [ngClass]="
          eraseButtonFlag && comboFormControl.value && !(defaultValue && comboFormControl.value.key === defaultValue.key)
            ? 'active-filter'
            : ''
        "
      >
        @if (comboFormControl.value.defaultFlag) {
          <mat-icon [ngClass]="{ 'list-mode': listModeFlag, disabled: comboFormControl.value.disabledFlag }">star</mat-icon>
        }
        @if (comboFormControl.value.disabledFlag) {
          <mat-icon [ngClass]="{ 'list-mode': listModeFlag, disabled: comboFormControl.value.disabledFlag }">not_interested</mat-icon>
        }
        @if (comboFormControl.value.parent && !listModeFlag && displayParentLabelFlag) {
          <span [class.disabled]="comboFormControl.value.disabledFlag"> {{ comboFormControl.value.parent.label }} / </span>
        }
        <span [class.disabled]="comboFormControl.value.disabledFlag">{{ comboFormControl.value.label }}</span>
      </mat-select-trigger>
    }
    @if (nullableOption && !requiredFlag) {
      <mat-option [ngClass]="{ 'list-mode': listModeFlag }">
        <span class="no-option-selected">{{ nullableOption }}</span>
      </mat-option>
      <mat-divider></mat-divider>
    }
    @for (comboModel of options; track comboModel.key) {
      <mat-option [ngClass]="{ 'list-mode': listModeFlag }" [value]="comboModel">
        @if (comboModel.separator) {
          <mat-divider></mat-divider>
        }
        @if (comboModel.defaultFlag) {
          <span><mat-icon [class.disabled]="comboModel.disabledFlag">star</mat-icon></span>
        }
        @if (comboModel.disabledFlag) {
          <span><mat-icon [class.disabled]="comboModel.disabledFlag">not_interested</mat-icon></span>
        }
        @if (comboModel.parent && displayParentLabelFlag) {
          <span [class.disabled]="comboModel.disabledFlag" [class.indented]="comboModel.parent"> {{ comboModel.parent.label }} / </span>
        }
        <span [class.disabled]="comboModel.disabledFlag" [class.indented]="comboModel.parent && !displayParentLabelFlag">{{
          comboModel.label
        }}</span>
      </mat-option>
    }
  </mat-select>
  @if (eraseButtonFlag) {
    <button
      (click)="eraseFilterClickedHandler(); $event.stopPropagation()"
      [attr.aria-label]="'Effacer le filtre de recherche'"
      [disabled]="disabled"
      class="xsmall-icon-button"
      mat-icon-button
      matSuffix
      matTooltip="Effacer le filtre de recherche"
    >
      <mat-icon>clear</mat-icon>
    </button>
  }
  @if (comboFormControl.hasError('required')) {
    <mat-error>{{ requiredFieldValidatorMessage }}</mat-error>
  }
  <mat-hint> {{ hint }} </mat-hint>
</mat-form-field>
